import { useMutation } from 'query';
import { reportContentObject } from '../../services';

export const useReportContentObjectMutation = () =>
  useMutation<unknown, { id: string }>({
    async mutationFn({ id }) {
      await reportContentObject({ body: { abuse_report: { content_object_id: id } } });
    },
  });
